import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const CanadaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14472'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14472)'>
				<rect
					x='14.2852'
					width='5.71429'
					height='14'
					fill='#FF3131'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H5.71429V0H0V14Z'
					fill='#FF3131'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.6843 6.28201C11.4631 6.49878 11.0949 6.29838 11.1568 5.99494L11.4279 4.66661L10.4755 5.13328L9.99935 3.73328L9.52316 5.13328L8.57078 4.66661L8.84186 5.99494C8.90379 6.29838 8.53557 6.49878 8.31438 6.28201C8.19228 6.16235 7.99689 6.16235 7.87479 6.28201L7.6184 6.53328L6.66602 6.06661L7.14221 6.99994L6.90895 7.22854C6.77558 7.35924 6.77558 7.57398 6.90895 7.70468L8.09459 8.86661H9.52316L9.76125 10.2666H10.2374L10.4755 8.86661H11.9041L13.0898 7.70468C13.2231 7.57398 13.2231 7.35924 13.0898 7.22854L12.8565 6.99994L13.3327 6.06661L12.3803 6.53328L12.1239 6.28201C12.0018 6.16235 11.8064 6.16235 11.6843 6.28201Z'
					fill='#FF3131'
				/>
			</g>
		</svg>
	);
};

export default CanadaFlagIcon;
